export default "__VITE_ASSET__jkftf$Je__"